import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TooltipContent = ({ option }) => {
  const theme = useTheme();
  return (
    <Stack direction="column" spacing={0.3}>
      {option?.ClientName && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            fontSize: '0.85rem',
            lineHeight: 1.4,
          }}
        >
          {option.ClientName}
        </Typography>
      )}
      {option?.ClientShortName && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            color: theme.palette.text.secondary,
            fontSize: '0.78rem',
            lineHeight: 1.4,
          }}
        >
          {option.ClientShortName}
        </Typography>
      )}
    </Stack>
  );
};

const getTooltipStyle = (theme) => ({
  tooltip: {
    sx: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      fontSize: '0.85rem',
      padding: '8px 12px',
      fontWeight: 500,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.shadows[3],
    },
  },
  arrow: {
    sx: {
      color: theme.palette.background.paper,
      '&::before': {
        border: `1px solid ${theme.palette.divider}`,
      },
    },
  },
});

const SourceSystemInfo = ({ option, isVisibleSourceSystem }) => {
  if (isVisibleSourceSystem && option.SourceSystemRecords?.length > 0) {
    return (
      <Typography color="textSecondary" variant="inherit">
        {option.SourceSystemRecords.map(({ SourceSystemRecordID, SourceSystemName }) =>
          `${SourceSystemRecordID} - ${SourceSystemName}`).join(', ')}
      </Typography>
    );
  }

  const parts = [
    option?.SourceSystemRecordID,
    option?.ShortName && `- ${option.ShortName}`,
    option?.Facility && `- ${option.Facility}`,
  ].filter(Boolean).join(' ');

  return (
    <Typography color="textSecondary" variant="inherit">
      {parts}
      {!option?.Active && <Chip label="Inactive" size="small" color="default" sx={{ ml: 0.5 }} />}
    </Typography>
  );
};

export const optionDecorator = (props, option, renderOptionDecorator, isVisibleSourceSystem, isHover) => {
  if (!renderOptionDecorator) return null;

  const listItem = (
    <li {...props}>
      <Stack direction="column" justifyContent="flex-start" spacing={0.5} width="100%">
        {option.text || ' '}
        <SourceSystemInfo option={option} isVisibleSourceSystem={isVisibleSourceSystem} />
      </Stack>
    </li>
  );

  if (!isHover) return <span key={option.id}>{listItem}</span>;

  return (
    <ThemedTooltip key={option.id} option={option} listItem={listItem} />
  );
};

const ThemedTooltip = ({ option, listItem }) => {
  const theme = useTheme();
  return (
    <Tooltip
      title={<TooltipContent option={option} />}
      placement="right"
      arrow
      componentsProps={getTooltipStyle(theme)}
    >
      {listItem}
    </Tooltip>
  );
};
